document.addEventListener("DOMContentLoaded", () => {

    var fs_moreDesc1 = document.getElementById("fs_moreDesc1");
    var fs_lessBtn = document.getElementById("fs_lessBtn");

    fs_lessBtn.addEventListener('click', change)
    fs_moreDesc1.addEventListener('click', change)
    window.addEventListener('resize', change)

    if (window.innerWidth >= 992) {
        if (document.querySelector('.boost-pfs-filter-right-col')) {
            var height = document.querySelector('.boost-pfs-filter-right-col').offsetHeight;
            const interval = setInterval(() => {
                if (document.querySelector('.boost-sd__filter-product-list')) {
                    const style = document.createElement('style');
                    style.textContent = `
                        .boost-sd-left.boost-filter-tree-column {
                            margin-top: -${height + 36}px
                        }
                    `;
                    document.querySelector('#MainContent').appendChild(style)
                    clearInterval(interval);
                }
            }, 200)
        }
    }

    function change() {
        if (window.innerWidth >= 992) {
            if (document.querySelector('.boost-pfs-filter-right-col')) {
    
                var height = document.querySelector('.boost-pfs-filter-right-col').offsetHeight;
    
                    if (document.querySelector('.boost-sd__filter-product-list')) {
                        const style = document.createElement('style');
                        style.textContent = `
                            .boost-sd-left.boost-filter-tree-column {
                                margin-top: -${height + 36}px
                            }
                        `;
                        document.querySelector('#MainContent').appendChild(style)
                    }
            }
        }
    }
})